import { createContext } from 'react'

const Context = createContext({
    freeTrial: {
        isModalOpen: false,
    },
})

export default Context